export default __webpack_public_path__ + "static/media/section-7.8eb40f23.png";